<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  [class]="isShowDetailPage||isShowRequestDetailPage || isShowReportPage?'d-none':''"
  (onSelectAll)="onSelectAll($event)"
>
  <!----------------------------------------- Title Buttons ----------------------------------------->
  <ng-container before-btns *ngIf="showExportItems">
    <!-- groupDeletion btn -->
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>

    <!-- setItemActiveStatus pause btn -->
    <div [matTooltip]="'common.do_pause' | translate">
      <button
        [disabled]="setItemActiveStatusSelectedIds?.length == 0||!isEnablePauseStatus"
        (click)="callGroupSetItemActiveStatus(false)"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-pause mdi-20px tw-p-0 text-warning"></i>
      </button>
    </div>

    <!-- setItemActiveStatus play btn -->
    <div [matTooltip]="'common.do_play' | translate">
      <button
        [disabled]="setItemActiveStatusSelectedIds?.length == 0||!isEnablePlayStatus"
        (click)="callGroupSetItemActiveStatus(true)"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-play mdi-20px tw-p-0 text-success"></i>
      </button>
    </div>

    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>
  </ng-container>
  <!----------------------------------------- Table Content ----------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row,i)"
        [class.row-active]="rowIndexSelected==i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <td>
          <div class="form-check tw-text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mt-[1px] tw-mr-0"
              (click)="onAddSelectedId($event, item, row)"
              [attr.data-checkbox-id]="item.id"
            />
          </div>
        </td>

        <!-- id -->
        <td>
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- isPeriodic -->
        <td>
          <td-value type="boolean" [value]="item?.isPeriodic"></td-value>
        </td>

        <!-- userName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- status -->
        <td>
          <ng-container>
            <span
              [smartSmsRequestStatusStyle]=" item?.status"
              [matTooltip]="(item?.status)|enumToText:SmartSmsStatusTypesEnumValues"
            >
            </span>
          </ng-container>
        </td>

        <!-- CreationLocation -->
        <td>
          <span class="tw-text-sm">
            {{ item?.creationLocation | enumToText : CreationLocationEnumValues
            }}</span
          >
        </td>

        <!-- StartLocation -->
        <td>
          <span class="tw-text-sm">
            {{ item?.startLocation | enumToText : CreationLocationEnumValues
            }}</span
          >
        </td>

        <!--statusDatetime-->
        <td>
          <td-value type="dateTime" [value]="item?.statusDatetime"></td-value>
        </td>

        <!--startDatetime-->
        <td>
          <td-value type="dateTime" [value]="item?.startDatetime"></td-value>
        </td>

        <!--endDatetime-->
        <td>
          <td-value type="dateTime" [value]="item?.endDatetime"></td-value>
        </td>

        <!--created-->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!--------------------------------------- operations --------------------------------------->

        <td class="sticky-td">
          <a mat-icon-button [matMenuTriggerFor]="menu">
            <i class="mdi mdi-dots-vertical text-navyBlue mdi-20px"></i>
          </a>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- refresh button -->
            <div
              *ngIf="(item?.status == SmartSmsRequestStatus.Waiting || item?.status == SmartSmsRequestStatus.PartOfRequestIsCompleted) && item.isPeriodic == false"
              app-menu-btn
              icon="mdi mdi-refresh mdi-20px"
              color="blue"
              [title]="'common.refresh'"
              (click)="onRefreshRow(item, i)"
            ></div>

            <!--send p2p smart sms-->
            <div
              *ngIf="(item?.status == SmartSmsRequestStatus.Done || item?.status == SmartSmsRequestStatus.PartOfRequestIsCompleted) && item.isPeriodic == false"
              app-menu-btn
              icon="mdi mdi-note-check mdi-20px"
              color="indigo"
              [title]="'common.sendP2PSmart'"
              (click)="onSendP2PSmart(item.id, 'sendP2pSmartSms')"
            ></div>

            <!-- *ngIf="item?.isPeriodic" -->
            <!--SmartReqStatisticWithRequestDetails-->
            <div
              *ngIf="isShowRequestReport(item?.startDatetime, item?.endDatetime, item?.isPeriodic)"
              app-menu-btn
              icon="mdi mdi-chart-bar-stacked mdi-20px"
              color="red"
              [title]="'common.reportBuilder'"
              (click)="onShowSmartReqStatisticWithRequestDetailsApi(item.id, item?.isPeriodic)"
            ></div>

            <!--detail-->
            <div
              app-menu-btn
              icon="mdi mdi-text-box-search-outline mdi-20px"
              color="blue"
              [title]="'common.detail'"
              (click)="onShowDetails(item.id, item.title, item.isPeriodic)"
            ></div>

            <!--request detail-->
            <div
              app-menu-btn
              icon="mdi mdi-text-box-search-outline mdi-20px"
              color="indigo"
              [title]="'common.requestDetail'"
              (click)="onShowRequestDetails(item.id,item)"
            ></div>

            <!--edit campaign btn-->
            <div
              app-menu-btn
              *ngIf="item?.startDatetime && item?.endDatetime && item.isPeriodic && item?.endDatetime > currentDateTime"
              icon="edit"
              (click)="onUpdatePeriodicSmartSms(item, 'smartSmsRequestConfirmData')"
            ></div>

            <!-- #region confirm button -->
            <div
              app-menu-btn
              *ngIf="(item?.status == SmartSmsRequestStatus.Done || item?.status == SmartSmsRequestStatus.PartOfRequestIsCompleted) && item.isPeriodic == false"
              icon="mdi mdi-note-check mdi-20px"
              color="green"
              [title]="'common.confirmSmartSmsRequest'"
              (click)="onConfirmSmartSms(item, 'smartSmsRequestConfirmData', i)"
            ></div>

            <!-- #endregion -->

            <!-- #region create recepient in periodic type -->
            <div
              app-menu-btn
              *ngIf="item.isPeriodic == true"
              icon="mdi mdi-note-check mdi-20px"
              color="green"
              [title]="'common.createRecepientForPeriodicSmartSms'"
              (click)="onConfirmSmartSms(item, 'smartSmsRequestConfirmData', i)"
            ></div>

            <!-- #endregion -->

            <!--#region active/deactive peridoic-->
            <div
              app-menu-btn
              *ngIf="item.isPeriodic == true && item?.isActive"
              icon="mdi mdi-pause mdi-20px"
              color="yellow"
              [title]="'common.do_pause'"
              (click)="onSetItemActiveStatus(item, false)"
            ></div>

            <div
              app-menu-btn
              *ngIf="item.isPeriodic == true && item?.isActive == false"
              icon="mdi mdi-play mdi-20px"
              color="green"
              [title]="'common.do_play'"
              (click)="onSetItemActiveStatus(item, true)"
            ></div>

            <!--#endregion-->
            <!-- delete button -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.title)"
            ></div>

            <!-- <mat-divider *ngIf="showExportItems"></mat-divider>
            <div
              *ngIf="showExportItems"
              mat-menu-item
              class="tw-flex-center text-navyBlue border-bottom"
              (click)="onExportRequestClick(item.id)"
            >
              <i
                class="mdi mdi-file-export mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
              <span class="mat-menu-title tw-font-medium"
                >{{pageVocabs+"exportRequest"| translate}}</span
              >
            </div>
            <div
              *ngIf="showExportItems && item?.isPeriodic==false"
              mat-menu-item
              class="tw-flex-center text-navyBlue border-bottom"
              (click)="onExportStatus(item.id)"
            >
              <i
                class="mdi mdi-file-export mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
              <span class="mat-menu-title tw-font-medium"
                >{{pageVocabs+"exportStatus"| translate}}</span
              >
            </div> -->

            <!-- <mat-divider *ngIf="showExportItems "></mat-divider> -->
            <!-- <div
              mat-menu-item
              class="tw-flex-center text-navyBlue border-bottom"
              (click)="importStatusFromFile(item.id)"
              *ngIf="showExportItems && item?.isPeriodic==false"
            >
              <i
                class="mdi mdi-file-import mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
              <span class="mat-menu-title tw-font-medium"
                >{{pageVocabs+"importRequestStatus"| translate}}</span
              >
              <input
                #importStatusFileInput
                type="file"
                style="display: none"
                (change)="importRequestStatusFromFileChange($event)"
                accept=".json"
              />
            </div> -->
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<app-smart-sms-detail
  *ngIf="isShowRequestDetailPage"
  [detailModel]="requestDetailPageModel"
  [selectedItem]="selectedItem"
  (closeFormPage)="isShowRequestDetailPage = false; showParent = true;getParentQueryString();;;"
></app-smart-sms-detail>

<!-- report  -->
<app-send-smart-sms-request-report
  *ngIf="isShowReportPage"
  [isPeriodic]="isPeriodic"
  (closePage)="isShowReportPage=false; showParent = true;getParentQueryString();"
  [model]="reportModel"
>
</app-send-smart-sms-request-report>

<!-------------------------------------------- help -------------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="SmartSendRequests"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
